import { Question } from "~/types/questionTypes"

export function excludeHiddenFields(fields: Question[]) {
  return fields.filter((f) => {
    const isDate =
      f.fieldType === "text" && f.fieldLabel.toLowerCase() === "date"
    if (isDate) return false

    if (f.fieldAnnotation === "") return true

    const annotations = f.fieldAnnotation.split(/\s+/)
    const hiddenAnnotations = ["@HIDDEN", "@HIDDEN-FORM", "@HIDDEN-APP"]
    return !annotations.some((annotation) =>
      hiddenAnnotations.includes(annotation)
    )
  })
}
